export const methodConstants = {
  LOGIN: '/api/login',
  LOGOUT: '/api/logout',
  //GET_LAYOUT_URL: '/api/layouts',
  GET_LAYOUT_URL: '/api/layout/vision',
  //GET_ALERTS_URL: '/api/alerts',
  GET_ALERTS_URL: '/api/layout/alerts',
  GET_PAIR_CODE: '/api/accounts/devices/auth_codes',
  GET_MOBILE_DEVICES: '/api/accounts/devices',
  REMOVE_DEVICE: '/api/accounts/devices/{:deviceId}',
  VALIDATE_CLAIM_CODE: '/api/give/rewardCodes/validate',
  GET_TRANSLATIONS: '/api/translations/0001543530/victoriesaccounts',
  GET_BANKACCOUNT_SUMMARY_POINTS: '/api/accounts/bank/{:bankId}/points',
  GET_BANKACCOUNT_SUMMARY_ACCESS: '/api/accounts/bank/{:bankId}/accessCodes',
  GET_RECEIVED: '/api/wall/history/received',
  GET_SENT: '/api/wall/history/given',
  GET_PERSONAL_INFO: '/api/perf/users/accounts/personalInfo',
  GET_PROPERTIES_URL: '/api/customers/{:customerId}/properties',
  GET_BANK_OVERVIEW_INFO: '/api/accounts/bank/overview',
  GET_ORDERS_OVERVIEW_INFO: '/api/accounts/orders',
  GET_SKILLS: '/api/accounts/skills',
  GET_ACCOUNT_PRINT: '/api/myaccount/bankAccountSingleBank.seam?cid={:cid}',
  GET_FACEBOOK_URL: '/api/accounts/programs/{:programId}/facebookUrl',
  GET_CATALOG_API: '/ng/catalog.jsf',
  GET_ORDERS_AWARDS: '/api/accounts/orders/{:orderId}/awards',
  GET_ORDERS_DETAILS: '/api/accounts/orders/{:orderId}',
  GET_SEARCH: '/api/accounts/search',
  GET_BANK_ACTIVE_PROGRAMS: '/api/accounts/bank/{:bankId}/programs',
  GET_PRESENTATION_CERTIFICATE: '/api/give/v2/presentationCertificate?nominationNomineeIds={:nominationNomineeId}',
  GET_EPRODUCT_URL: '/api/give/eProduct/{:eProductId}',
  GET_ECARD_IMAGE: '/api/give/eCardImage/{:userUploadedImageId}',
  GET_ACCOUNT_ALERTS_URL: '/api/accounts/alerts',
  GET_ACCOUNT_DETAILS_ALERT_API: '/api/accounts/bank/{:bankId}/pointsExpiry',
  SEARCH_USER: '/api/search/users?q={:employeeId}',
  GET_PERMISSIONS_ORDER_SEARCH: 'api/accounts/permissions/order/search',
  GET_ORDER_SEARCH_PROGRAMS: '/api/accounts/programs',
  EDW_ORDERS: '/api/accounts/edw/orders',
  EDW_ORDERS_RECENT: '/api/accounts/edw/orders/recent?days={:rangeValue}',
  RESEND_ECARD: '/api/give/eCard/resend?eProductRecipientId=',
  GET_SKILLS_NEW: '/api/skills-finder/user-skills?userId={:systemUserId}&customerId={:customerId}',
  GET_ECARD_PRINT: '/api/accounts/eProduct/{:eProductId}/pdf',
  GET_AVATAR_URL: '/api/users/current',
  GET_TASKS_COUNT: '/api/give/currentTasksCount',
  VALIDATE_USER_TOKEN: '/login/token/info',
  GET_USER_DETAILS: '/users?ids={:userId}',
  GET_GREATWORK_TRANSLATIONS: '/api/translations/{:stp}/greatwork/',
  GET_NOMINATION_PDF: '/ui/greatwork/viewEvent?eId={:nominationNomineeId}&type=nomination'
};
